<template>
  {{ displayPrice }}
</template>

<script setup lang="ts">
import { computed } from 'vue'

// TODO: should we keep PriceDiplay?
// it would make more sense to do like on Cart summary
// and do calculation before

const props = defineProps<{
  currencyCode: string
  value: number
}>()

const displayPrice = computed(() => {
  const rate = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: props.currencyCode,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(props.value)
  return rate
})
</script>
